import {
  Grid,
  Radio,
  RadioGroup,
  FormControl,
  FormHelperText,
  FormLabel,
  FormControlLabel,
} from '@mui/material';

const MuiRadioGroup = ({
  field,
  form: { touched, errors },
  name,
  label,
  itemValues,
  itemLabels,
  sx,
  helpModal,
  ...props
}) => {
  const hasError = touched[field.name] && errors[field.name] && true;

  return (
    <FormControl sx={sx}>
      <FormLabel sx={{ fontSize: '1rem', color: 'black', display: 'inline' }} error={hasError}>
        {label}
      </FormLabel>
      {helpModal}

      <RadioGroup name={name} {...props} {...field} sx={{ fontSize: '1rem', color: 'black' }}>
        {itemValues.map((val, index) => (
          <FormControlLabel key={val} value={val} control={<Radio />} label={itemLabels[index]} />
        ))}
        <Grid container>
          <FormHelperText sx={{ m: 0 }} error={hasError}>
            {hasError && errors[field.name]}
          </FormHelperText>
        </Grid>
      </RadioGroup>
    </FormControl>
  );
};

export default MuiRadioGroup;
